import { css } from 'styled-components'
import {
  textClickAnim,
  whiteBackgroundAnim,
  buttonClickScaleAnim,
  innerTabAnim
} from './InteractionsKeyframes'

export const InteractionsAnim = () => {
  const buttonClickScale = css`
    animation: ${buttonClickScaleAnim} 0.33s 1 forwards;
  `
  const whiteBackground = css`
    animation: ${whiteBackgroundAnim} 0.33s 1 forwards;
  `
  const textClick = css`
    animation: ${textClickAnim} 0.33s 1 forwards;
  `
  const innerTab = css`
    animation: ${innerTabAnim} 0.167s 1 forwards;
  `
  return {
    textClick,
    whiteBackground,
    buttonClickScale,
    innerTab
  }
}
